export const formatAdvertorialGifs = (
    images = {
        allFile: {
            edges: [
                {
                    node: {
                        publicURL: ``,
                    },
                },
            ],
        },
    },
) => {
    return images.allFile.edges
        .map((edge) => {
            return edge.node.publicURL
        })
        .sort((a, b) => {
            const filenameAParts = a.split('/')
            const filenameBParts = b.split('/')
            const filenameA = filenameAParts[filenameAParts.length - 1]
            const filenameB = filenameBParts[filenameBParts.length - 1]
            if (filenameA > filenameB) return 1
            return -1
        })
}
